module.exports = __webpack_public_path__ + "static/img/504.b091cd29.jpg";